import typoMixin from '@/styles/mixins/typo-mixin'
import { makeStyles, css } from '@conexasaude/hero'

type makeStylesProps = {
  isOpened?: boolean
}

const useStyles = makeStyles<makeStylesProps>({
  container: () => css`
    width: 100%;
    max-width: 550px;
  `,

  togglerWrapper: ({ colors, borderRadius, shadows }) => css`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 80px;
    padding: 0 24px;
    border: 1px solid ${colors.extra.disabled_bg};
    border-radius: ${borderRadius.sm};
    background-color: ${colors.extra.background};
    box-shadow: ${shadows[1]};
    cursor: pointer;
    z-index: 2;
  `,

  togglerTitle: ({ typography, colors }) => css`
    display: flex;
    align-items: center;

    .hero-collapsible__start-icon {
      margin-right: 8px;
    }

    p {
      ${typoMixin({ typography }, 'h4')};
      color: ${colors.neutral[500]};

      @media (max-width: 638px) {
        font-size: 16px;
      }
    }
  `,

  contentWrapper: ({ colors, borderRadius }, { isOpened }) => css`
    position: relative;
    top: -12px;
    width: auto;
    height: ${isOpened ? 'auto' : '0'};
    padding: ${isOpened ? '36px 24px 24px' : '0 24px'};
    border: 1px solid ${colors.extra.disabled_bg};
    border-radius: ${borderRadius.sm};
    background-color: ${colors.extra.background};
    transform: ${isOpened ? 'scaleY(1)' : 'scaleY(0)'};
    transform-origin: top;
    transform-style: preserve-3d;
    transition: 0.1s;
    z-index: 1;
  `,
})

export { useStyles }
